import Echo from 'laravel-echo';

// A single, app-wide Echo connection. Components subscribe through `privateChannel`
// (Echo dedupes channels by name) and never create their own instance or disconnect
// this one, so the websocket stays alive for the whole session.

let echo = null;

function ensureEcho() {
    if (!echo) {
        window.Pusher = require('pusher-js');

        echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.MIX_PUSHER_APP_KEY,
            cluster: process.env.MIX_PUSHER_APP_CLUSTER,
            wsHost: window.location.hostname,
            wsPort: process.env.MIX_LARAVEL_WEBSOCKETS_PORT,
            forceTLS: false,
            disableStats: true
        });
    }

    return echo;
}

export function privateChannel(name) {
    return ensureEcho().private(name);
}

// Tear the connection down completely — only on logout / project switch.
export function disconnectEcho() {
    if (echo) {
        echo.disconnect();
        echo = null;
    }
}
